<template>
    <div class="ProjectView">
        <!-- Renders during SSR with the org snapshot embedded in the project, so crawlers get the
             title (h1) and description; parts that need the full org appear once it has loaded. -->
        <OpportunityPageLayout
v-if="isVisible || preview" back-label="Späť na projekty" :minified="minified" :preview="preview" reverse-bottom-style
            :to="{
                name: 'dobrovolnictvo-dobrovolnicke-projekty',
                query: $route.query,
                hash: `#r-id-${projectId}`
            }">

            <ProjectViewLayoutTop :minified="minified" :org="org || orgSnapshot" :project="project" />

            <template #middle>
                <OpportunityPageButtons
v-if="!minified && org" :id="project.id" fixed-on-mobile :org-name="org.title"
                    :org-type="org.type" :preview="preview" :title="project.title" type="project">
                    <ProjectRequestButton :org="org" :preview="preview" :project="project" />
                </OpportunityPageButtons>
            </template>

            <template #left>
                <ProjectViewLayoutLeft :project="project" />
            </template>
            <template #right>
                <div class="space-y-8 sm:space-y-20">
                    <ProjectViewLayoutRight :project="project" />

                    <ProjectViewOrgInfoBlock v-if="org" :org="org" />

                    <PublishedUpdatedDateBlock :published-at="project.publishedAt" :updated-at="project.updatedAt" />

                </div>
            </template>
        </OpportunityPageLayout>



        <div v-else>
            <div class="text-center py-8">
                <p class="text-gray-500 dark:text-txt-body">Táto ponuka už nie je aktuálna.</p>
                <NuxtLink
class="text-blue-600 dark:text-blue-300 hover:underline" :to="{
                        name: 'dobrovolnictvo-dobrovolnicke-projekty'
                    }">
                    Zobraziť všetky aktuálne projekty
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import type { Org, OrgMeta } from '#shared/types/Org'
import type { Project } from '#shared/types/Project'
import { useOrgs } from '@/composables/orgs/useOrgs'

const props = defineProps<{
    project: Project
    published?: boolean
    preview?: boolean
    minified?: boolean
}>()

// State
// The full org is loaded on the client after hydration (onMounted), so SSR and the first
// client render agree; until then the top section uses the snapshot embedded in the project.
const org = ref<Org | null>(null)
const route = useRoute()
const { loadOrg } = useOrgs()

// Computed
const projectId = computed(() => route.params.id as string)
const isVisible = computed(() => props.project.visibility !== 'private');

const orgSnapshot = computed((): OrgMeta | undefined => {
    return props.project.orgMeta?.id ? props.project.orgMeta : undefined
})

// Methods
async function fetchData() {
    try {
        if (props.project.orgId) {
            org.value = await loadOrg(props.project.orgId)
        }
    } catch (error) {
        console.error('Error loading organization:', error)
    }
}

// Lifecycle
onMounted(() => {
    fetchData()
})
</script>

<style lang="postcss" scoped>
.ProjectView {
    width: 100%;
}
</style>
